import { put } from "redux-saga/effects";
// import _ from "lodash";
import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import { keysToCamelCase } from "lib/helpers";
import messages from "../messages";

function* getAdminProjectNotes(action) {
  const { projectId } = action.payload;
  const { success, data, error } = yield* makeRequest.get(
    `/provider_leads/${projectId}/notes`, // correct endpoint?
    {},
  );
  if (success && data) {
    yield put(
      actions.setProjectNotes({
        notes: data.body.notes && data.body.notes.map((n) => keysToCamelCase(n)),
        availableTags: data.body.available_tags && data.body.available_tags.map((t) => keysToCamelCase(t)),
      }),
    );
  } else {
    return getErrorActions({
      error,
      message: messages.ERROR_GETTING_ADMIN_PROJECT_NOTES,
    });
  }
  return null;
}

export default getAdminProjectNotes;
